<template>
    <div class="container-fluid">
        <!-- sign up -->
        <div class="row bg-black">
            <div class="user-account">

                <user-account-header :user="user"></user-account-header>

                <!-- user tabs actions -->
                <div class="user-actions">
                    <div class="container">
                        <div class="tabs-container">
                            <div class="tabs-left">
                                <ul class="nav nav-tabs sections-profile-tabs col-xs-12 col-sm-4">
                                    <li @click="currentTab = 'account-info', editing = false" :class="{'active': currentTab == 'account-info'}">
                                        <a class="pointer" data-toggle="tab" href="#account-info">ACCOUNT INFORMATION</a>
                                    </li>
                                    <li @click="currentTab = 'saved-build'" :class="{'active': currentTab == 'saved-build'}">
                                        <a class="pointer" data-toggle="tab" href="#saved-build">SAVED BUILDS</a>
                                    </li>
                                    <li @click="currentTab = 'order-history'" :class="{'active': currentTab == 'order-history'}">
                                        <a class="pointer" data-toggle="tab" href="#order-history">ORDER HISTORY</a>
                                    </li>
                                    <li @click="currentTab = 'write-review', newReview = true" :class="{'active': currentTab == 'write-review'}">
                                        <a class="pointer" data-toggle="tab" href="#write-review">WRITE A REVIEW</a>
                                    </li>
                                    <li @click="currentTab = 'create-tickets'" :class="{'active': currentTab == 'create-tickets'}">
                                        <a class="pointer" data-toggle="tab" href="#create-tickets">CREATE A TICKET</a>
                                    </li>
                                    <li @click="currentTab = 'tickets'" :class="{'active': currentTab == 'tickets'}">
                                        <a class="pointer" data-toggle="tab" href="#tickets">TICKETS</a>
                                    </li>
                                    <li @click="currentTab = 'return-management'" :class="{'active': currentTab == 'return-management'}">
                                        <a class="pointer" data-toggle="tab" href="#return-management">RETURN MANAGEMENT</a>
                                    </li>
                                </ul>
                                <div class="tab-content col-xs-12 col-sm-8 p-a-0">
                                    <!-- account-information -->
                                    <div id="account-info"
                                        class="tab-pane"
                                        v-if="currentTab == 'account-info'"
                                        :class="{'active': currentTab == 'account-info'}"
                                        >
                                        <user-account-information
                                            v-if="!editing"
                                            @isEditing="isEditing">
                                        </user-account-information>
                                        <!-- /.account-information -->
                                        <button @click="editing = true" v-if="!editing"
                                            type="button" name="edit-account"
                                            class="btn btn-sm btn-round btn-green pull-right">EDIT
                                            <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
                                        </button>
                                        <div >
                                            <!-- editing-fields -->
                                            <edit-user-info
                                                v-if="editing"
                                                @isEditing="isEditing">
                                            </edit-user-info>
                                            <!--editing-fields -->
                                        </div>
                                    </div>
                                    <!-- saved-builds -->
                                    <div id="saved-build"
                                        class="tab-pane"
                                        :class="{'active': currentTab == 'saved-build'}"
                                        >
                                        <saved-builds></saved-builds>
                                    </div>
                                    <!-- /.saved-builds -->
                                    <!-- order-history -->
                                    <div id="order-history"
                                        class="tab-pane"
                                        :class="{'active': currentTab == 'order-history'}">
                                        <div class="panel-body">
                                            <div class="user-orders">
                                                <!-- no Data -->
                                                <!-- <div class="text-center">
                                                    <h4 class="text-white m-b-md">You have not made a purchase from LETSBLD.com yet!</h4>
                                                    <router-link class="btn btn-sm btn-round btn-green" to="">GO TO BLD <i class="fa fa-long-arrow-right" aria-hidden="true"></i></router-link>
                                                    </div> -->
                                                <!-- /.no Data -->
                                                <order-history></order-history>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- /.order-history -->
                                    <!-- write-a-review -->
                                    <div id="write-review"
                                        class="tab-pane"
                                        :class="{'active': currentTab == 'write-review'}">
                                        <div class="panel-body">
                                            <div class="user-reviews-history">
                                                <create-review @newReview="showNewReview"
                                                    :newReview="newReview">
                                                </create-review>
                                                <!--TODO: Use this when we get the order -->
                                                <!-- no Data -->
                                                <!--<div class="text-center">-->
                                                <!--<h4 class="text-white m-b-md">You have not made a purchase from LETSBLD.com yet!</h4>-->
                                                <!--<router-link class="btn btn-sm btn-round btn-green" to="">GO TO BLD <i class="fa fa-long-arrow-right" aria-hidden="true"></i></router-link>-->
                                                <!--</div>-->
                                                <!-- /.no Data -->
                                            </div>
                                        </div>
                                    </div>
                                    <!-- /.write-a-review -->
                                    <!-- created-tickets -->
                                    <div id="create-tickets"
                                        class="tab-pane"
                                        :class="{'active': currentTab == 'create-tickets'}"
                                        >
                                        <create-ticket
                                            @reloadTickets="reloadTickets = true">
                                        </create-ticket>
                                    </div>
                                    <!-- /.created-tickets -->
                                    <!-- tickets-history -->
                                    <div id="tickets"
                                        class="tab-pane"
                                        :class="{'active': currentTab == 'tickets'}">
                                        <tickets
                                            :reloadTickets="reloadTickets"
                                            @createTicket="currentTab = 'create-tickets'"
                                            @ticketsLoaded="setTickets()">
                                        </tickets>
                                    </div>
                                    <!-- /.tickets-history -->
                                    <!-- returns-management -->
                                    <div id="return-management"
                                        class="tab-pane"
                                        :class="{'active': currentTab == 'return-management'}">
                                        <return-management @createRma="currentTab = 'create-tickets'"></return-management>
                                    </div>
                                    <!-- /.returns-management -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- /.user tabs actions -->
                <!-- /.Welcome Title with User Name -->
            </div>
        </div>
        <!-- /.sign up -->
    </div>
</template>


<script>
import UserAccountHeader from "./user-account-header.vue";
import CreateTicket from "./create-ticket.vue";
import CreateReview from "./create-review.vue";
import UserAccountInformation from "./user-account-info.vue";
import EditUserInfo from "./edit-user-info.vue";
import SavedBuilds from "./saved-builds.vue"
import OrderHistory from "./order-history.vue"
import Tickets from "./tickets.vue"
import ReturnManagement from "./return-management.vue"
import { getUserData } from "../../util/helpers.js";

export default {
    name: "UserAccount",
    components: {
        UserAccountHeader,
        CreateTicket,
        UserAccountInformation,
        EditUserInfo,
        SavedBuilds,
        CreateReview,
        OrderHistory,
        Tickets,
        ReturnManagement
    },
    data() {
        return {
            editing: false,
            newReview: true,
            reloadTickets: false,
            currentTab: "account-info",
            user: getUserData()
        }
    },
    created() {
        if (!_.isEmpty(this.$route.query)) {
            this.currentTab = this.$route.query.currentTab;
        } else if (!_.isEmpty(this.$route.params)) {
            this.currentTab = this.$route.params.currentTab;
        }

        this.user.username = Cookies.get("username");
        this.user.email = Cookies.get("email");
    },
    watch: {
        "$route.query"(query) {
            if (query) {
                this.currentTab = this.$route.query.currentTab;
            }
        },
        currentTab(tab) {
            const currentTab = this.$route.path + "?currentTab=" + tab;
            history.pushState({}, null, currentTab);
        }
    },
    methods: {
        isEditing(value) {
            this.editing = value;
        },
        showNewReview() {
            this.newReview = false;
        },
        setTickets() {
            this.reloadTickets = false;
        }
    }
}
</script>
